<div class="page-content bg-light">
    <div class="dz-bnr-inr bg-secondary dz-bnr-inr-md"
        style="background-image:url(https://ezhuthupizhai.in/wp-content/uploads/2024/03/Banner_3-scaled-1.jpg);">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="dz-bnr-inr-entry text-start">
                        <h1 class="text-white">Discover our exclusive collection of products</h1>
                        <nav aria-label="breadcrumb" class="breadcrumb-row">
                            <ul class="breadcrumb text-white">
                                <li class="breadcrumb-item"><a href="/home" class="text-white"> Home</a></li>
                                <li class="breadcrumb-item text-white">Shop</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-products></app-products>